import { Injectable } from '@angular/core';
import {PayPalOrder} from '../models/paypal-order.model';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  apiKey: string;
  // tslint:disable-next-line:variable-name
  private _order: PayPalOrder;
  constructor() {}

  get order(): PayPalOrder {
    return this._order;
  }

  set order(value: PayPalOrder) {
    this._order = value;
  }
}
